import { SocialButtonProps } from 'survey/types';
import { copyTextToClipboard } from 'common/utils/copyTextToClipboard';

export default function FacebookShareButton({
  url,
  buttonText,
  handleClick,
  shareQuote,
}: SocialButtonProps): JSX.Element {
  const onClick = async (): Promise<void> => {
    await copyTextToClipboard(shareQuote);
    window.open(
      url,
      'popUpWindow',
      'height=600,width=800,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes'
    );
    handleClick();
  };

  return (
    <button
      type="button"
      className="btn btn-block social-btn facebook spec-facebook-share"
      aria-label="Copy Quote and Share on Facebook"
      onClick={onClick}
    >
      <i className="fab fa-facebook-f" />
      <span>{buttonText}</span>
    </button>
  );
}
